import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { UAParser } from "ua-parser-js";
export var getOsName = function() {
    var _getOS, _getWindow;
    return ((_getOS = new UAParser((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.navigator.userAgent).getOS()) === null || _getOS === void 0 ? void 0 : _getOS.name) || "";
};
